import React, { useEffect, useState } from 'react'
import { IconButton, Menu } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import ChangePayment from './ChangePayment'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import RestartSubscription from './RestartSubscription'
import CancelSubscription from './CancelSubscription'

interface Props {
  disabled: boolean
}

export default function BillingMenu({ disabled }: Props) {
  const queryClient = useQueryClient()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  function onCloseMenu() {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton onClick={handleClick} disabled={disabled}>
        <MoreVertIcon />
      </IconButton>

      <Menu
        id="basic-menu" anchorEl={anchorEl}
        open={open} onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <ChangePayment />
        <RestartSubscription onCloseMenu={onCloseMenu} />
        <CancelSubscription onCloseMenu={onCloseMenu} />
      </Menu>

    </>
  )
}
